import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { DashboardFilterBar } from '@/features/dashboard-filters';
import { useHeaderFilters } from '@/features/header-filters';
import { useProjectSiteParams } from '@/shared/lib';

import { useConsignmentsFilters } from '../lib/use-consignments-filters';
import { ConsignmentsPage } from './consignments-page';

export function ConsignmentsWithFilters() {
  const { t } = useTranslation();
  const { projectId, siteId } = useProjectSiteParams();
  const { setFilterConfig, setSearchConfig } = useHeaderFilters();

  const {
    urlState,
    searchQuery,
    activeFiltersCount,
    organizationOptions,
    setOrganizationSearch,
    setSelectedOrganization,
    handleFilterChange,
    handleSearchChange,
    handleDateRangeChange,
    handleReset,
    handleApplyFilters,
    handleToggleAllSites,
    isFiltersDirty,
    hasDefaultFilters
  } = useConsignmentsFilters();

  useEffect(() => {
    const config = {
      defaultValue: searchQuery,
      placeholder: t('cmrlist.filters.search.placeholder', 'Search consignments...'),
      onChange: handleSearchChange,
      enabled: true
    };
    setSearchConfig(config);
  }, [handleSearchChange, setSearchConfig, t, searchQuery]);

  useEffect(() => {
    const filterContent = (
      <DashboardFilterBar
        variant="consignments"
        options={urlState}
        onOptionChange={handleFilterChange}
        onDateRangeChange={handleDateRangeChange}
        consignmentNumber={urlState.requestNumber}
        onConsignmentNumberChange={(value) => handleFilterChange('requestNumber', value)}
        organizationOptions={organizationOptions}
        selectedOrganization={urlState.orgId}
        onOrganizationChange={setSelectedOrganization}
        onOrganizationSearchChange={setOrganizationSearch}
        waybill={urlState.waybill}
        onWaybillChange={(value) => handleFilterChange('waybill', value)}
        allSites={urlState.allSites === 'true'}
        onAllSitesChange={handleToggleAllSites}
        resetKey={`${projectId}-${siteId}`}
      />
    );

    setFilterConfig({
      id: 'consignments-filters',
      title: t('cmrlist.filters.title', 'Filter Consignments'),
      content: filterContent,
      activeCount: activeFiltersCount,
      onReset: handleReset,
      onApply: handleApplyFilters,
      isApplyDisabled: !isFiltersDirty,
      isResetDisabled: hasDefaultFilters
    });
  }, [
    activeFiltersCount,
    handleFilterChange,
    handleDateRangeChange,
    handleReset,
    handleApplyFilters,
    handleToggleAllSites,
    isFiltersDirty,
    hasDefaultFilters,
    setFilterConfig,
    setSearchConfig,
    projectId,
    siteId,
    t,
    urlState,
    organizationOptions,
    setSelectedOrganization,
    setOrganizationSearch
  ]);

  return <ConsignmentsPage />;
}
